interface ArticleTagProp {
  children: any;
}

function ArticleTag({ children }: ArticleTagProp) {
  return (
    <article className="tw-w-full tw-flex tw-flex-col tw-justify-between !tw-max-h-fit tw-font-[Avenir]">
      {children}
    </article>
  );
}

export default ArticleTag;
